import { createContext, useContext } from 'react';
// @ts-ignore: We don't instantiate it here, because it doesn't have a default value.
const ApplicationContext = createContext(null);
ApplicationContext.displayName = 'ApplicationContext';
function useApplicationContext() {
    const context = useContext(ApplicationContext);
    if (!context) {
        throw Error(`[ApplicationContext]: Context ${ApplicationContext.displayName} is not provided.`);
    }
    return context;
}
export { ApplicationContext, useApplicationContext, };
//# sourceMappingURL=application-context.js.map